import Vue from "vue";

Vue.filter("whitespace", function(value) {
  value = value.split("_-");
  value = value.join(" ");
  return value;
});

Vue.filter("titlecase", function(value) {
  if (!value) {
    return "";
  }
  value = value.toLowerCase();
  value = value.split(" ");
  value = value.map(function(word) {
    if (word.length == 2) {
      return word.toUpperCase();
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
  });
  value = value.join(" ");
  return value;
});
